module.exports = __webpack_public_path__ + "img/KH.a05cb07e.svg";